<li class="navigation-menu-item-container" [ngClass]="{'active':active,'seperator':seperator, 'none':item.hide}" (click)="onClick($event)" (mouseover)="onHover($event)" (mouseleave)="onMoveOut($event)">
    <div class="icon-container" [attr.tid]="item.tid">
        <smart-icon *ngIf="item.icon && item.id !== 'intralink'" class="menu-image" [name]="item.icon.name">
        </smart-icon>
        <img tid="intralink" src="./assets/images/intralinks_logo.png" class="img-intralink" alt="intralink" *ngIf="item.id === 'intralink'">
    </div>
    <label class="menu-label">{{item.caption}}</label>
    <smart-icon class="menu-image label_arrow" name="angle-right" *ngIf="expandable"></smart-icon>
    <ul class="sub-container" [ngClass]="{'has-element': item.items&&item.items.length>1}" *ngIf="showSubItems">
        <div class="cushion">
            <div class="sub-item-container" *ngFor="let subMenu of item.items; let i=index">
                <navigation-menu-item [item]="subMenu" [touchMode]='touchMode' [seperator]='subMenu.type==="add"' [eventSubject]='eventSubject'></navigation-menu-item>
            </div>
        </div>
    </ul>
</li>